import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-angle-right",
  "use": "arrow-angle-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-angle-right\"><path d=\"M5.22 11.22c-.195.196-.374.626 0 1 .375.375.805.196 1 0l4-4-4-4c-.195-.195-.621-.378-1 0-.378.379-.195.805 0 1l3 3-3 3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol